import React, { useEffect } from 'react';

import classNames from 'classnames';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import DataTable from './DataTable';
import { valueFormatter } from './utils';
import ValueDifference from '../ValueDifference';
import { formatValueDifference } from '../valueDifferenceUtils';
import { useWidgetContext } from '../Widget/WidgetContext';

interface Props {
  data: any;
}

const DataTableAverage = ({ data }: Props) => {
  const { type, setCSVData, filters } = useWidgetContext();
  const { community } = useCommunityViewContext();
  const valueDisplay = filters?.valueDisplay;

  useEffect(() => {
    const communitiesData = data.map((row: any) => {
      const formattedValue = valueFormatter(row.value, type, true, undefined, community);
      const diff = formatValueDifference(row.difference ?? null, type, valueDisplay, community);
      return [row.community_name, diff ? `${formattedValue} ${diff}` : formattedValue];
    });
    const exportData = [['COMMUNITY', 'VALUE'], ...communitiesData];
    setCSVData(exportData);
  }, [community, data, type, valueDisplay, setCSVData]);

  const columns = [
    {
      title: 'COMMUNITY',
      dataIndex: 'community_name',
      width: '50%',
      align: 'left' as const,
      render: (value: any, record: any) => (
        <span
          className={classNames({ highlighted: record.community_type == COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY })}
        >
          {value}
        </span>
      ),
    },
    {
      title: 'VALUE',
      dataIndex: 'value',
      align: 'center' as const,
      render: (value: any, record: any) => (
        <span>
          {valueFormatter(value, type, true, undefined, community)}
          <ValueDifference difference={record?.difference} widgetType={type} valueDisplay={valueDisplay} />
        </span>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      dataSource={data}
      scroll={{ x: 'max-content' }}
      pagination={false}
      rowKey={(record: any) => record?.community_name}
    />
  );
};

export default DataTableAverage;
